import React from "react";

import {
Badge
} from "antd";

import {
BellOutlined
} from "@ant-design/icons";


const Notification = ({
theme,
count = 5,
onClick
})=>{


return (

<Badge count={count}>

<BellOutlined

onClick={onClick}

style={{

fontSize:20,

color:theme.text,

cursor:"pointer"

}}

/>

</Badge>

);


};


export default Notification;